import University from "../networking/models/University";
import FormQuestion from '../networking/models/FormQuestion';
import {UniversityPart} from '../networking/repos/UniversityRepository';

export interface QuestionAnswers {
    labels: string[];
    values: string[];
}

export interface Question {
    id: number;
    name: string;
    question: string;
    answers: QuestionAnswers;
    question_type?: string;
}

export const formQuestionsToTableQuestions = (formQuestions: FormQuestion[]): Question[] => {
    return formQuestions.map(question => ({
            id: question.id!,
            name: question.name,
            question: question.question,
            answers: {
                labels: question.answers.map(answer => answer.label).filter(label => label !== ''),
                values: question.answers.map(answer => answer.value)
            },
            question_type: question.question_type
        })
    );
}

export const partsWithTableQuestions = (parts: UniversityPart[]) => {
    return parts.map(part => ({
        ...part,
        questions: formQuestionsToTableQuestions(part.active_questions)
    }));
};

export const dummyUniversities: University[] = [
    {
        name: "University of Amsterdam",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
        location: { 
            country: "Netherlands",
            city: "Amsterdam"
        },
        rating: 3,
        images: [{
            url: "test.test",
            order: 1
        }],
        reviews: [
            {
                description: "Availability of services and resources at this university ",
                stars: 2
            }, 
            {
                description: "Availability of services and resources at this university ",
                stars: 3
            }, 
            {
                description: "Availability of services and resources at this university ",
                stars: 1
            }, 
        ],
        socialMediaAccounts: [{
            name: "Instagram",
            slug: "instagram",
            url: "#"
        }, {
            name: "Twitter",
            slug: "twitter",
            url: "#"
        }, {
            name: "Facebook",
            slug: "facebook",
            url: "#"
        }, {
            name: "Website",
            slug: "website",
            url: "#"
        }],
    }, {
        name: "University of lissabon",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
        location: { 
            country: "Portugal",
            city: "Lissabon"
        },
        rating: 3,
        images: [{
            url: "test.test",
            order: 1
        }],
        reviews: [
            {
                description: "Availability of services and resources at this university ",
                stars: 2
            }, 
            {
                description: "Availability of services and resources at this university ",
                stars: 3
            }, 
            {
                description: "Availability of services and resources at this university ",
                stars: 1
            }, 
        ],
        socialMediaAccounts: [{
            name: "instagram",
            slug: "insta",
            url: "#"
        }, {
            name: "twitter",
            slug: "twitter",
            url: "#"
        }, {
            name: "facebook",
            slug: "facebook",
            url: "#"
        }, {
            name: "website",
            slug: "website",
            url: "#"
        }],
    }, {
        name: "University of London",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
        location: { 
            country: "UK",
            city: "London"
        },
        rating: 3,
        images: [{
            url: "test.test",
            order: 1
        }],
        reviews: [
            {
                description: "Availability of services and resources at this university ",
                stars: 2
            }, 
            {
                description: "Availability of services and resources at this university ",
                stars: 3
            }, 
            {
                description: "Availability of services and resources at this university ",
                stars: 1
            }, 
        ],
        socialMediaAccounts: [{
            name: "instagram",
            slug: "insta",
            url: "#"
        }, {
            name: "twitter",
            slug: "twitter",
            url: "#"
        }, {
            name: "facebook",
            slug: "facebook",
            url: "#"
        }, {
            name: "website",
            slug: "website",
            url: "#"
        }],
    }
];
